import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGithubComponent } from './simple-icons-github.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGithubComponent ],
    exports:      [ SimpleIconsGithubComponent ],
    bootstrap:    []
})
export class SimpleIconsGithubModule {}
